import { useCallback } from 'react'
import LookupField from './LookupField'

const BrandSummary = ({ brand }) => (
  <span className="brand-lookup-summary">
    <strong className="brand-lookup-summary__name">{brand.brand_name}</strong>
    <span className="brand-lookup-summary__id">Brand ID: {brand.brand_id}</span>
    <span className="brand-lookup-summary__ownership">
      {brand.is_target_owned ? 'Target Owned Brand' : 'National Brand'}
    </span>
  </span>
)

const BrandLookupField = (props) => {
  const getInputValue = useCallback((brand) => brand.brand_name, [])
  const getOptionKey = useCallback((brand) => brand.brand_id, [])
  const renderBrand = useCallback((brand) => <BrandSummary brand={brand} />, [])

  return (
    <LookupField
      errorMessage="We could not validate this brand. Please try again."
      getInputValue={getInputValue}
      getOptionKey={getOptionKey}
      noResultsMessage="No matching brands found."
      placeholder="Search by brand name"
      renderOption={renderBrand}
      renderSelection={renderBrand}
      searchingMessage="Searching brands…"
      {...props}
    />
  )
}

export default BrandLookupField
